<template>
		<div class="content home-page">
		<Header></Header>

			<div class="error-page-content">
				<div class="error-panel">
					<p class="fs50 ac error-title"><span>{{$t('error')}}</span></p>
					<div class="error-msg">
              {{msg}}
          </div>
          <button class="button error-login-btn" @click="goLogin">{{$t('Login')}}</button>
				</div>
			</div>
		</div>
</template>
<script>
import Header from '../components/HelpHeader.vue'
export default {
    components:{
		Header
    },
    data() {
        return {
          msg:''

		    }
    },
	created(){
    if(this.$route.query.msg){
      this.msg = this.$route.query.msg;
    }
	},
    methods: {
    goLogin(){
      this.$router.push({path:'/login'})
    },
	}
}
</script>
<style>
  .error-page-content {
    min-height: calc(100vh - 3.2rem);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.4rem;
  }

  .error-panel {
    width: 100%;
    text-align: center;
    color: #fff;
  }

  .error-title {
    margin-bottom: 0.3rem;
  }

  .error-msg {
    min-height: 0.6rem;
    margin: 0 auto 0.5rem;
    font-size: 0.3rem;
    line-height: 0.46rem;
    word-break: break-word;
  }

  .error-login-btn {
    width: 4.8rem;
    max-width: 100%;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/page/error.vue